import React from 'react';

import { TextField, Typography } from '@mui/material';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { FormattedMessage } from 'react-intl';

import OperatorSessionExtendedPanel from '@components/operatorSession/OperatorSessionExtendedPanel';
import { useOperatorSession } from '@contexts/OperatorSeesionProvider';

type OperatorSessionNotesProps = {
    isOpen: boolean;
    close: () => void;
};

const OperatorSessionNotes = ({ isOpen, close }: OperatorSessionNotesProps) => {
    const { additionalInfo, addNotes } = useOperatorSession();
    const { theme } = useTheme();

    return (
        <OperatorSessionExtendedPanel isOpen={isOpen} closePanel={close}>
            <Typography
                variant="h5"
                component="h1"
                sx={{
                    color: theme?.custom?.brand?.textMain || 'text.primary',
                }}>
                <FormattedMessage
                    id="OperatorSessionNotes.title"
                    defaultMessage="Notes from your session"
                />
            </Typography>
            <Typography variant="body2" color="text.secondary">
                <FormattedMessage
                    id="OperatorSessionNotes.description"
                    defaultMessage="Help your colleagues know how this session went"
                />
            </Typography>

            <TextField
                label={
                    <FormattedMessage
                        id="OperatorSessionNotes.notes"
                        defaultMessage="Session notes"
                    />
                }
                onChange={({ target: { value } }) => addNotes(value)}
                sx={{
                    mt: theme.spacing(6.25),
                    mb: 0,
                }}
                value={additionalInfo?.text}
                rows={13}
                autoFocus
                multiline
                fullWidth
            />
        </OperatorSessionExtendedPanel>
    );
};
export default OperatorSessionNotes;
